exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nodata-container[data-v-1735868e] {\n  background-color: white;\n}\nh1.highlights[data-v-1735868e] {\n  font-size: 5rem;\n}", ""]);

// exports
